module.exports = __webpack_public_path__ + "static/media/icon-location-oneway-pickup.3af82253.svg";